export function isValidHex(str) {
  return /^[0-9A-Fa-f]+$/.test(str);
}